// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-more-filter-clear-button {
  background-color: #d2042d !important;
  color: #fff !important;
  border-color: #d2042d;
  font-weight: 500 !important;
  font-size: 16px !important;
}
.view-more-filter-clear-button:hover {
  background-color: #910621 !important;
  border-color: #910621 !important;
}
@media screen and (min-width: 1441px) {
  .view-more-filter-modal.ant-modal {
    top: 235px !important;
    left: -285px !important;
    width: auto;
  }
}
@media (min-width: 1025px) and (max-width: 1440px) {
  .view-more-filter-modal.ant-modal {
    top: 235px !important;
    left: -150px !important;
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/view-more-filters/ViewMoreFilter.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;EACb;AACF;AACA;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":[".view-more-filter-clear-button {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  border-color: #d2042d;\n  font-weight: 500 !important;\n  font-size: 16px !important;\n}\n.view-more-filter-clear-button:hover {\n  background-color: #910621 !important;\n  border-color: #910621 !important;\n}\n@media screen and (min-width: 1441px) {\n  .view-more-filter-modal.ant-modal {\n    top: 235px !important;\n    left: -285px !important;\n    width: auto;\n  }\n}\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .view-more-filter-modal.ant-modal {\n    top: 235px !important;\n    left: -150px !important;\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
